import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, MessageSquare, FileCheck } from 'lucide-react';
export function SolutionSection() {
  const steps = [{
    step: '01',
    title: 'Elige el tema',
    description: 'Identifica el conflicto recurrente (sueño, comida, tareas) usando nuestra lista rápida.',
    icon: <CheckCircle2 className="w-6 h-6 text-white" data-id="element-199" />
  }, {
    step: '02',
    title: 'Usa el guión',
    description: 'Lee literalmente las frases diseñadas para abrir la conversación sin culpas ni ataques.',
    icon: <MessageSquare className="w-6 h-6 text-white" data-id="element-200" />
  }, {
    step: '03',
    title: 'Cierra el acuerdo',
    description: 'Rellena la plantilla de 5 minutos y pégala en la nevera. Tema cerrado.',
    icon: <FileCheck className="w-6 h-6 text-white" data-id="element-201" />
  }];
  return <section className="py-24 px-4 bg-brown text-cream relative overflow-hidden" data-id="element-202">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-203">
        <div className="absolute top-10 left-10 w-64 h-64 rounded-full bg-terracotta blur-3xl" data-id="element-204"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 rounded-full bg-blush blur-3xl" data-id="element-205"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-206">
        <div className="text-center mb-16" data-id="element-207">
          <motion.span initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-block text-terracotta-light font-medium tracking-widest uppercase text-sm mb-4" data-id="element-208">
            La Solución
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-5xl font-bold text-cream mb-6" data-id="element-209">
            El Método Acuerdos Express
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-cream/80 max-w-2xl mx-auto" data-id="element-210">
            Solo 10 minutos diarios. Guía clara. Resultados reales. <br data-id="element-211" />
            Funciona porque cierra los temas sin reabrirlos.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-212">
          {steps.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-2xl hover:bg-white/10 transition-colors" data-id="element-213">
              <div className="flex items-center justify-between mb-6" data-id="element-214">
                <span className="text-4xl font-serif font-bold text-terracotta opacity-50" data-id="element-215">
                  {item.step}
                </span>
                <div className="w-10 h-10 rounded-full bg-terracotta flex items-center justify-center shadow-lg" data-id="element-216">
                  {item.icon}
                </div>
              </div>
              <h3 className="text-xl font-bold text-cream mb-3" data-id="element-217">
                {item.title}
              </h3>
              <p className="text-cream/70 leading-relaxed" data-id="element-218">
                {item.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-16 text-center" data-id="element-219">
          <p className="text-cream/60 italic text-sm" data-id="element-220">
            Diseñado específicamente para la realidad de padres agotados.
          </p>
        </motion.div>
      </div>
    </section>;
}